export const screens = {
  SEARCH: 'search',
  DEPARTURE: 'departure',
  ARRIVAL: 'arrival',
  DATE: 'date',
  SEATS: 'seats',
};

export const screensFlow = [
  screens.DEPARTURE,
  screens.ARRIVAL,
  screens.SEATS,
  screens.DATE,
];

export const seatsLimit = 40;
